/*
 * @description:
 * @author: Jason Wong
 * @since: 2025-04-03 16:26:18
 */
const PREFIX = "SAAS_";

export function readLocal(key) {
  return localStorage.getItem(PREFIX + key);
}

export function writeLocal(key, val) {
  localStorage.setItem(PREFIX + key, val);
}
